import { Text } from '$tablet-app/src/app/components/Text/Text';
import { FormRowIcon } from '$tablet-app/src/app/forms/components/FormRowIcon';
import { color, layout, margins, spacing } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import DateTimeField from '../DateTimeField';

type dateFunc = (date: Date) => void;

interface StartEndFieldProps {
  start: Date;
  end?: Date;
  onStartChange: dateFunc;
  onEndChange?: dateFunc;
}

const StartEndField: FC<StartEndFieldProps> = ({
  start,
  end,
  onStartChange,
  onEndChange,
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <FormRowIcon icon="clock" />
      </View>

      <View style={styles.dateFieldContainer}>
        <DateTimeField value={start} onChange={onStartChange} />
      </View>

      {end && onEndChange ? (
        <>
          <View style={styles.centerSpacer}>
            <View style={styles.spacerLine} />

            <View style={styles.toContainer}>
              <Text>to</Text>
            </View>

            <View style={styles.spacerLine} />
          </View>

          <View style={styles.dateFieldContainer}>
            <DateTimeField value={end} onChange={onEndChange} />
          </View>
        </>
      ) : null}
    </View>
  );
};

// Styles
const styles = StyleSheet.create({
  container: {
    ...layout.verticallyCenteredRow,
    borderColor: color.border,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    zIndex: 1000,
    minHeight: 90,
  },
  iconContainer: {
    ...layout.centerContent,
  },
  spacerLine: { height: 30, borderLeftColor: color.border, borderLeftWidth: 1 },
  centerSpacer: {
    alignItems: 'center',
  },
  dateFieldContainer: {
    justifyContent: 'center',
    flex: 1,
    zIndex: 10,
    ...margins.ml3,
  },
  toContainer: {
    padding: spacing[1],
    paddingHorizontal: spacing[3],
    borderColor: color.border,
    borderWidth: 1,
    borderRadius: 5,
  },
});

export default StartEndField;
